import { render } from "./ShareGroupButton.vue?vue&type=template&id=00d0cc2e"
import script from "./ShareGroupButton.vue?vue&type=script&lang=js"
export * from "./ShareGroupButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__